<template>
  <div class>
    <h1 class="ml-8 lowercase text-blue-dark font-bold">{{ appName }}</h1>

    <div class="flex justify-center mt-6">
      <img
        class="rounded-full w-48 h-48 border-8 border-blue-lightest"
        src="https://via.placeholder.com/200"
      >
    </div>

    <div class="flex-col mt-4">
      <span class="block text-xl text-center">Full User Name</span>
      <span class="block text-sm text-center mt-3 text-grey-darkest">Staff No.</span>
    </div>

    <div class="mt-10">
      <ul class="list-reset">
        <li>
          <a class="block pl-10 text-lg no-underline text-blue-dark py-3" href>
            <fa class="mr-3" icon="home" fixed-width/>Home
          </a>
        </li>
        <li>
          <a class="block pl-10 text-lg no-underline text-black py-3" href>
            <fa class="mr-3" icon="chart-bar" fixed-width/>Analytics
          </a>
        </li>
        <li>
          <a class="block pl-10 text-lg no-underline text-black py-3" href>
            <fa class="mr-3" icon="sign-out-alt" fixed-width/>Sign Out
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheSidebar",

  data() {
    return {
      appName: process.env.APP_NAME
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TheSidebar.vue